/** Import react section **/
import React, { useState } from 'react'
import propTypes from 'prop-types'

/**Import Material UI section */
import { Button, Tooltip, ButtonGroup, Typography } from '@material-ui/core'

/**Import components sections */
import Popper from '../../common/ReportDateRange/Popper'

/**Import resources section */
import { DateRangeSelectStyles } from '../resources/DataRangeStyles.js'
/**
 * 
 * @param {*} props 
 */
const ReportDateRange = (props) => {
    const classes = DateRangeSelectStyles();
    const { data, onDownloadReport, isDownloadReport, onDateRangeChange, startDate, endDate } = props;

    const [settingsEl, setSettingsEl] = useState(null);
    

    /**Hanlde  menu open popper */
    const handleMenuOpen = (event) => {
        setSettingsEl(event.currentTarget);
    };

    /**Close menu popper filter */
    const onHandleNullSetting = () => {
        setSettingsEl(null);
    };

    
    

    return (
        <div className={classes.root}>
            <ButtonGroup component="span" size='small' variant="outlined" color="primary" className={classes.buttonsGroupContainer}>
                <Tooltip component="span" title='Select a range date'  >
                    <Button
                        className={classes.buttonsGroup}
                        onClick={settingsEl ? onHandleNullSetting: handleMenuOpen}
                        disabled={isDownloadReport}
                    >
                        <Typography>
                            {`${startDate.format('YYYY-MM-DD')} - ${endDate.format('YYYY-MM-DD')}`}
                        </Typography>
                    </Button>
                </Tooltip>
            </ButtonGroup>
            <Popper
                settingsEl={settingsEl}
                setSettingsEl={onHandleNullSetting}
                data={data}
                startDate={startDate}
                endDate={endDate}
                onDateRangeChange={onDateRangeChange}
                onDownloadReport={onDownloadReport}
                isDownloadReport={isDownloadReport}
                OnlySave={true}
            />
        </div>
    )
}

ReportDateRange.propTypes = {
	/**
	 * Callback execute for fownload report by range date 
	 */
    onDownloadReport: propTypes.func.isRequired,
    /**
     * Determinate if is download report
     */
    isDownloadReport: propTypes.bool.isRequired,
}

ReportDateRange.defaultProps = {
    isDownloadReport: false,
    onDownloadReport: () =>
        console.warn('Callback [onDownloadReport] no defined'),
}

export default ReportDateRange
